import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { apiError, fmtIDR } from "./util";

const FILTERS = [["open", "Belum lunas"], ["paid", "Lunas"], ["all", "Semua"]];
const PO_STATUS = { OPEN: "Belum lunas", PAID: "Lunas" };

function Summary({ totals }) {
    const items = [
        ["Nilai Penjualan", totals.sales_value_idr, "Total nilai order PO"],
        ["Sudah Dibayar (produk)", totals.paid_idr, "DP + pelunasan yang sudah diterima"],
        ["Sisa Tagihan", totals.outstanding_idr, "Nilai penjualan dikurangi yang sudah dibayar"],
        ["Sisa Ongkir", totals.shipping_outstanding_idr, "Ongkir yang belum dibayar customer"],
    ];
    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="po-ledger-totals">
            {items.map(([label, v, hint]) => (
                <div key={label} className="bg-white border border-mist rounded-sm p-3">
                    <div className="text-[10px] uppercase tracking-widest text-neutral-400">{label}</div>
                    <div className="font-serif text-xl mt-1">{fmtIDR(v)}</div>
                    <div className="text-[10px] text-neutral-400 mt-0.5">{hint}</div>
                </div>
            ))}
        </div>
    );
}

export default function PoLedger({ brand, refreshKey }) {
    const [status, setStatus] = useState("open");
    const [data, setData] = useState(null);
    useEffect(() => {
        api.get("/reporting/po-orders", { params: { brand, status } })
            .then(({ data }) => setData(data))
            .catch(async (e) => { toast.error(await apiError(e)); setData({ items: [], totals: {} }); });
    }, [brand, status, refreshKey]);
    return (
        <div className="space-y-4" data-testid="po-ledger">
            <div className="flex gap-1.5">
                {FILTERS.map(([v, label]) => (
                    <button key={v} type="button" onClick={() => setStatus(v)} data-testid={`po-filter-${v}`}
                        className={`px-3 py-1 rounded-full text-[10px] uppercase tracking-widest border transition-colors ${status === v ? "bg-sage-dark text-white border-sage-dark" : "border-mist text-neutral-500 hover:border-sage-dark"}`}>
                        {label}
                    </button>
                ))}
            </div>
            {data && <Summary totals={data.totals} />}
            {data && !data.items.length && <div className="text-sm text-neutral-400 border border-dashed border-mist rounded-sm p-6" data-testid="po-empty">Belum ada order PO.</div>}
            {data && data.items.length > 0 && (
                <div className="overflow-x-auto border border-mist rounded-sm bg-white">
                    <table className="w-full text-sm">
                        <thead className="bg-neutral-50 text-neutral-500 text-xs">
                            <tr>
                                {["ID Order PO", "Tanggal Order", "Customer", "Produk", "Nilai Penjualan", "Dibayar", "Sisa Tagihan", "Ongkir", "Sisa Ongkir", "Status"].map((h) => (
                                    <th key={h} className="text-left font-normal px-3 py-2 whitespace-nowrap">{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {data.items.map((p) => (
                                <tr key={p.id} className="border-t border-mist" data-testid={`po-row-${p.po_order_id}`}>
                                    <td className="px-3 py-2.5 font-mono text-xs">{p.po_order_id}</td>
                                    <td className="px-3 py-2.5 whitespace-nowrap">{p.order_date}</td>
                                    <td className="px-3 py-2.5">{p.customer}</td>
                                    <td className="px-3 py-2.5">{p.product_name}</td>
                                    <td className="px-3 py-2.5 tabular-nums">{fmtIDR(p.sales_value_idr)}</td>
                                    <td className="px-3 py-2.5 tabular-nums">{fmtIDR(p.paid_idr)}</td>
                                    <td className="px-3 py-2.5 tabular-nums font-medium" data-testid={`po-outstanding-${p.po_order_id}`}>{fmtIDR(p.outstanding_idr)}</td>
                                    <td className="px-3 py-2.5 tabular-nums">{fmtIDR(p.shipping_fee_idr)}</td>
                                    <td className="px-3 py-2.5 tabular-nums">{fmtIDR(p.shipping_outstanding_idr)}</td>
                                    <td className="px-3 py-2.5 text-xs uppercase tracking-widest">{PO_STATUS[p.status] || p.status}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
